export default __webpack_public_path__ + "static/media/Commander's Armguards of the Golden Sun.487e0383.jpg";